export default __webpack_public_path__ + "1cd4467a759a6ee94caf483ba7a0a610.png";